import React from "react";

import { Routes, Route, Navigate } from "react-router-dom";
// import jwt_decode from "jwt-decode";
// import setAuthToken from "../utils/setAuthToken";
// import { setCurrentUser, logoutuser } from "./actions/authActions";
// import EditAttendance from "../screens/attendance/editAttendance/EditAttendance";
import Access from "../screens/access/Access";
import AddHoliday from "../screens/holidays/AddHoliday";
import AllLocations from "../screens/locations/AllLocations";
import AllOthers from "../screens/hr/others/AllOthers";
import AllReimbursement from "../screens/hr/reimbursement/AllReimbursement";
import AllReports from "../screens/reports/allReports/AllReports";
import AllUsers from "../screens/users/AllUsers";
import AttendanceSheet from "../screens/attendance/attendanceSheet/AttendanceSheet";
import DailyAttendance from "../screens/attendance/daily/DailyAttendance";
import DailyCanteen from "../screens/canteen/daily/DailyCanteen";
import Dashboard from "../screens/dashboard/Dashboard";
import ExcelRegister from "../screens/auth/register/ExcelRegister";
import LoginPage from "../screens/auth/login/LoginPage";
import MissingAttendance from "../screens/attendance/missing/MissingAttendance";
import Mode from "../screens/mode/Mode";
import Otp from "../screens/auth/otp/Otp";
import PageMaintenance from "../component/PageMaintenance";
import PhotoRegister from "../screens/auth/register/photoRegister/PhotoRegister";
import PrivateRoute from "./PrivateRoute";
import RegisterLocation from "../screens/locations/RegisterLocation";
import RegisterUser from "../screens/auth/register/RegisterUser";
import Relation from "../screens/relation/Relation";
import ReportingManagers from "../screens/reports/reportingManagers/ReportingManagers";
import Rules from "../screens/rules/Rules";
import SelectLocationPage from "../screens/auth/login/SelectLocationPage";
import Setting from "../screens/settings/Setting";
import UserDetail from "../screens/userDetail/UserDetail";
import UserWiseAttendance from "../screens/attendance/userAttendance/UserWiseAttendance";
import DepartmentAttendance from "../screens/attendance/departAttendance/DepartmentAttendance";

import AddQuery from "../screens/query/addQuery/AddQuery";
import AllQuery from "../screens/query/allQuery/AllQueries";
import QueryDetails from "../screens/query/queryDetails/QueryDetails";
import DailyDpr from "../screens/reports/dpr/allDpr/DailyDpr";
import CreateDpr from "../screens/reports/dpr/addDpr/CreateDpr";
import AllDpr from "../screens/reports/dpr/allDpr/AllDpr";
import ChangeModule from "../screens/dashboard/settings/ChangeModule";
import ShiftChange from "../screens/hr/shiftChanges/ShiftChange";
import Profile from "../screens/profile.js/Profile";
import UserPhotos from "../screens/userPhoto/UserPhotos";
import AllShift from "../screens/hr/shiftChanges/AllShift";
import DynamicAttendanceSheet from "../screens/attendance/dynamicSheet/DynamicAttendanceSheet";
import CreateCanteenRule from "../screens/rules/CreateCanteenRule";
import CanteenSheet from "../screens/canteen/monthly/CanteenSheet";
import AllDevices from "../screens/devices/AllDevices";
import MyLeaves from "../screens/hr/leaves/MyLeaves";
import AllLeave from "../screens/hr/leaves/AllLeave";
import AddLeave from "../screens/hr/leaves/AddLeave";
import SingleMissing from "../screens/attendance/single/SingleMissing";
import SingleMissingAttendance from "../screens/hr/missingAttendances/SingleMissingAttendance";
import AddHod from "../screens/hr/addHod/AddHod";
import Updates from "../screens/updates/Updates";

// import Task from "../screens/task/Task";
// import LoadingPage from "../screens/loading/LoadingPage";
// import CreateNotice from "../screens/notice/CreateNotice";

const Navigation = () => {
  // const history = createHistory();
  return (
    <Routes>
      <Route element={<PrivateRoute />}>
        <Route
          path="/dashboard/:workerFullName/:workerDepartment"
          element={<Dashboard />}
          exact
        />
        <Route
          path="/hr/user/user-registration"
          element={<RegisterUser />}
          exact
        />
        <Route
          exact
          path="/hr/user/all-register-images"
          element={<UserPhotos />}
        />
        <Route
          exact
          path="/hr/location/location-registration"
          element={<RegisterLocation />}
        />
        <Route
          exact
          path="/hr/location/all-locations"
          element={<AllLocations />}
        />
        <Route
          exact
          path="/hr/user/all-users"
          element={<AllUsers />}
        />
        <Route
          exact
          path="/hr/user/all-users/:user_id"
          element={<UserDetail />}
        />
        <Route
          exact
          path="/hr/user/user-photo-register"
          element={<PhotoRegister />}
        />
        <Route
          exact
          path="/hr/user/user-csv-registration"
          element={<ExcelRegister />}
        />

        {/* attendance */}
        <Route
          exact
          path="/hr/attendance/user-daily-attendance"
          element={<DailyAttendance />}
        />
        <Route
          exact
          path="/hr/attendance/missing-daily-attendance"
          element={<MissingAttendance />}
        />
        <Route
          exact
          path="/hr/attendance/single-user-missing-daily-attendance"
          element={<SingleMissing />}
        />
        <Route
          exact
          path="/hr/all-attendance-to-regularized"
          element={<SingleMissingAttendance />}
        />
        <Route
          exact
          path="/hr/attendance/user-attendance-sheet"
          element={<AttendanceSheet />}
        />
        <Route
          exact
          path="/hr/attendance/user-report-sheet"
          element={<DynamicAttendanceSheet />}
        />
        <Route
          exact
          path="/hr/attendance/edit-user-attendance"
          element={<PageMaintenance />}
        />
        <Route
          exact
          path="/hr/attendance/user-attendance"
          element={<UserWiseAttendance />}
        />
        <Route
          exact
          path="/hr/attendance/user-department-attendance"
          element={<DepartmentAttendance />}
        />

        {/* leave */}
        <Route exact path="/hr/all-leaves" element={<AllLeave />} />
        <Route
          exact
          path="/user/apply-leave"
          element={<AddLeave />}
        />

        {/* canteen */}
        <Route
          exact
          path="/hr/canteen/user-daily-canteen"
          element={<DailyCanteen />}
        />

        {/* hr */}
        <Route
          exact
          path="/hr/all-leaves"
          element={<PageMaintenance />}
        />
        <Route
          exact
          path="/hr/all-reimbursement"
          element={<AllReimbursement />}
        />
        <Route
          exact
          path="/hr/change-shift"
          element={<ShiftChange />}
        />
        <Route exact path="/hr/all-shift" element={<AllShift />} />
        <Route exact path="/hr/others" element={<AllOthers />} />

        {/* rules */}
        <Route exact path="/hr/rules/all-rules" element={<Rules />} />

        {/* canteen rule */}
        <Route
          exact
          path="/hr/rules/all-canteen-rules"
          element={<CreateCanteenRule />}
        />
        <Route
          exact
          path="/hr/canteen/user-canteen-sheet"
          element={<CanteenSheet />}
        />
        <Route
          exact
          path="/hr/canteen/user-report-sheet"
          element={<PageMaintenance />}
        />
        <Route
          exact
          path="/hr/canteen/user-canteen"
          element={<PageMaintenance />}
        />
        <Route
          exact
          path="/hr/canteen/missing-daily-canteen"
          element={<PageMaintenance />}
        />

        {/* other rules */}
        <Route
          exact
          path="/hr/rules/all-holidays"
          element={<AddHoliday />}
        />
        <Route exact path="/hr/mode/all-modes" element={<Mode />} />

        {/* user page */}
        <Route
          exact
          path="/page-maintenance"
          element={<PageMaintenance />}
        />
        <Route exact path="/user/my-leave" element={<MyLeaves />} />
        <Route
          exact
          path="/user/change-password"
          element={<Setting />}
        />
        <Route
          exact
          path="/access/user-access"
          element={<Access />}
        />
        <Route
          exact
          path="/access/my-relations"
          element={<Relation />}
        />
        <Route
          exact
          path="/access/all-updates"
          element={<Updates />}
        />

        <Route exact path="/user/my-profile" element={<Profile />} />

        {/* dpr */}
        <Route exact path="/hr/add-hod" element={<AddHod />} />
        <Route exact path="/hr/dpr" element={<PageMaintenance />} />
        {/* notice */}
        <Route
          exact
          path="/users/notice"
          element={<PageMaintenance />}
        />
        {/* reports */}
        <Route
          exact
          path="/reports/reporting-managers"
          element={<ReportingManagers />}
        />
        <Route
          exact
          path="/reports/manager-reports"
          element={<AllReports />}
        />
        {/* query */}
        <Route
          exact
          path="/reports/query/add-query"
          element={<AddQuery />}
        />
        <Route
          exact
          path="/reports/query/all-query"
          element={<AllQuery />}
        />
        <Route
          exact
          path="/reports/query/query-detail/:query_id"
          element={<QueryDetails />}
        />
        <Route
          exact
          path="/devices/all-devices"
          element={<AllDevices />}
        />
        {/* daily progress report */}
        <Route
          exact
          path="/reports/dpr/dpr-detail/:dpr_id"
          element={<DailyDpr />}
        />
        {/* create progress report */}
        <Route
          exact
          path="/reports/dpr/create-dpr"
          element={<CreateDpr />}
        />
        {/* get all report from date */}
        <Route
          exact
          path="/reports/dpr/all-dpr"
          element={<AllDpr />}
        />
        {/* change module */}
        <Route
          exact
          path="/user/change-module"
          element={<ChangeModule />}
        />
        {/* tasks */}
        <Route
          exact
          path="/task/all-tasks"
          element={<PageMaintenance />}
        />
        <Route
          exact
          path="/auth/select-project"
          element={<SelectLocationPage />}
        />
      </Route>
      <Route exact path="/" element={<LoginPage />} />
      <Route exact path="/users/otp-verification" element={<Otp />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default Navigation;
